/**
 * Utilities to normalize text before sending it to the backend.
 * Removes accents and special characters to avoid issues with legacy APIs and OData.
 */
export class StringHelper {

  /**
   * Removes diacritics (accents) and symbols from a string.
   * Keeps only letters, numbers, and spaces.
   *
   * Example:
   * "Musculação!" -> "Musculacao"
   * "Açaí 100%"   -> "Acai 100"
   *
   * Use only in the payload sent to the API (not in the UI).
   */
  public static removeAccents(str: string): string {
    if (!str || typeof str !== 'string') {
      return str;
    }

    return str
      .replace(/\u00A0/g, ' ')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{L}\p{N}\s]/gu, '')
      .trim();
  }

  /**
   * Applies normalization only to literal values of an OData filter,
   * preserving the query syntax.
   *
   * Example:
   * contains(Name,'João') -> contains(Name,'Joao')
   */
  public static normalizeODataFilter(filter: string): string {
    if (!filter || typeof filter !== 'string') {
      return filter;
    }

    return filter.replace(/'((?:[^']|'')*)'/g, (_, value) => {
      return `'${this.removeAccents(value)}'`;
    });
  }
}